import { useEffect } from 'react';
import RegistrationForm from './components/registration-form';
import { tealiumEvent } from '../../utils/tealium';
import { TEALIUM_EVENTS } from '../../utils/tealium-events';

const RegistrationPage = () => {
  useEffect(() => {
    tealiumEvent(TEALIUM_EVENTS.REGISTRATION.START);
  }, []);

  return (
    <>
      <RegistrationForm />
    </>
  );
};

export default RegistrationPage;
